<form class="input-autocomplete-form" ngNoForm (submit)="$event.preventDefault(); $event.stopPropagation()">
  <input
    #autocompleteRef="cdkOverlayOrigin"
    cdkOverlayOrigin
    type="text"
    class="input-autocomplete-input text-b2-m-700 text-md-b4-l-700"
    [placeholder]="placeholder"
    autocapitalize="off"
    autocomplete="off"
    autocorrect="off"
    enterkeyhint="search"
    spellcheck="false"
    [(ngModel)]="value"
    [disabled]="disabled"
    (input)="onInputValueChange()"
    (keydown.enter)="onInputEnterKeyDown()"
    [maxlength]="maxLength"
    (focus)="onInputFocus()"
  />
  <div class="input-autocomplete-icons">
    @if (!loading) {
      <sd-icon class="icon-size-s icon-size-md-m color-black-warm-400" [type]="iconTypes.SEARCH"></sd-icon>
    } @else {
      <sd-loader theme="orange" [size]="isMobileSmDown() ? 's' : 'm'"></sd-loader>
    }
  </div>
</form>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="autocompleteRef"
  [cdkConnectedOverlayOpen]="opened()"
  (detach)="close()"
  (overlayOutsideClick)="close()"
  [cdkConnectedOverlayPositions]="[
    { originY: 'bottom', overlayY: 'top', originX: 'start', overlayX: 'start', offsetY: isMobileSmDown() ? 0 : 8 },
  ]"
>
  @if (items) {
    <sd-dropdown-menu (click)="close()">
      @for (item of items; track $index) {
        <sd-dropdown-menu-item (click)="onDropdownMenuItemSelect(item)">
          @if (itemTemplate) {
            <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
          } @else {
            {{ item.label }}
          }
        </sd-dropdown-menu-item>
      }
    </sd-dropdown-menu>
  }
</ng-template>
